/**
 * shadcn utility — canonical `cn` function used by @/components/ui/* primitives.
 *
 * Re-exports from `@/domains/shared/services/cn` so shadcn-generated components
 * import from `@/lib/utils` per shadcn convention without duplicating the merger config.
 */
export { cn } from "@/domains/shared/services/cn";
